export const CUSTOM_EMOJI_METADATA = {
  'ee-leon-txapela': {
    label: 'León con Txapela',
    keywords: ['leon', 'txapela', 'athletic', 'zurigorri', 'base', 'orgullo', 'sonrisa']
  },
  'ee-leon-enfadado': {
    label: 'León Enfadado',
    keywords: ['enfado', 'rabia', 'arbitro', 'furia', 'rugido', 'rojo', 'indignado']
  },
  'ee-leon-expulsado': {
    label: 'León Expulsado',
    keywords: ['roja', 'tarjeta', 'injusticia', 'expulsion', 'robo', 'incredulo']
  },
  'ee-leon-facepalm': {
    label: 'León Facepalm',
    keywords: ['facepalm', 'tierra tragame', 'lamento', 'error', 'cagada', 'desastre']
  },
  'ee-leon-gafas-sol': {
    label: 'León "Deal With It"',
    keywords: ['gafas de sol', 'chulo', 'victoria', 'sobrado', 'crack', 'papeada']
  },
  'ee-leon-gurugol': {
    label: 'León Guruzeta (Máscara)',
    keywords: ['guruzeta', 'guru', 'gurugol', 'mascara', 'delantero', 'gol']
  },
  'ee-leon-jaurewizard': {
    label: 'León Jaurewizard',
    keywords: ['jauregizar', 'jauregi', 'mago', 'magia', 'sombrero', 'varita']
  },
  'ee-leon-kamehameha': {
    label: 'León Kamehameha',
    keywords: ['kamehameha', 'dragon ball', 'goku', 'onda vital', 'energia', 'fuerza']
  },
  'ee-leon-lesionado': {
    label: 'León Lesionado',
    keywords: ['lesion', 'muletas', 'vendaje', 'hospital', 'baja', 'tocado']
  },
  'ee-leon-triste': {
    label: 'León Triste',
    keywords: ['triste', 'llorando', 'derrota', 'pena', 'bajon', 'desconsuelo']
  },
  'ee-leon-var': {
    label: 'León VAR',
    keywords: ['var', 'arbitro', 'pantalla', 'rectangulo', 'decision', 'escandalo']
  },
  'ee-leon-vivian': {
    label: 'León Vivian (El Teniente)',
    keywords: ['vivian', 'teniente', 'saludo', 'militar', 'central', 'defensa']
  },
  'ee-leon-yeray': {
    label: 'León Yeray (El Cerrojo)',
    keywords: ['yeray', 'cerrojo', 'candado', 'muro', 'defensa', 'porteria a cero']
  },
  'ee-leon-berenguer': {
    label: 'León Berenguer (El Toro)',
    keywords: ['berenguer', 'toro', 'cuernos', 'furia', 'bravo', 'extremo']
  },
  'ee-leon-padilla': {
    label: 'León Padilla (El Mariachi)',
    keywords: ['padilla', 'portero', 'mariachi', 'mexico', 'sombrero', 'paradon']
  },
  'ee-leon-galarreta': {
    label: 'León Galarreta (Galaxy)',
    keywords: ['galarreta', 'ruiz de galarreta', 'galaxy', 'astronauta', 'espacio', 'jugon']
  },
  'ee-leon-yuri': {
    label: 'León Yuri (El Rebelde)',
    keywords: ['yuri', 'berchiche', 'rebelde', 'cuero', 'chupa', 'duro', 'lateral']
  },
  'ee-leon-rego': {
    label: 'León Rego (Magno)',
    keywords: ['rego', 'magno', 'cesar', 'laurel', 'imperio', 'victoria']
  },
  'ee-leon-prados': {
    label: 'León Prados (Zelai)',
    keywords: ['prados', 'beñat', 'zelai', 'cortacesped', 'pulmon', 'todocampista']
  },
  'ee-leon-chef': {
    label: 'León Chef (A la cazuela)',
    keywords: ['chef', 'cocinero', 'cazuela', 'bakalao', 'cocina', 'cocinando']
  },
  'ee-leon-palomitas': {
    label: 'León Palomitas (Drama)',
    keywords: ['palomitas', 'drama', 'cine', 'pillo sitio', 'pelea', 'salseo']
  },
  'ee-leon-risas': {
    label: 'León Risas (LOL)',
    keywords: ['risa', 'lol', 'rofl', 'carcajada', 'gracioso', 'suelo', 'humor']
  },
  'ee-leon-ibaigane': {
    label: 'León Ibaigane',
    keywords: ['ibaigane', 'directiva', 'presidente', 'traje', 'maletin', 'despacho']
  },
  'ee-leon-golpe-mesa': {
    label: 'León Golpe en la Mesa',
    keywords: ['golpe mesa', 'punetazo', 'furia', 'basta ya', 'decision', 'romper']
  },
  'ee-senor-saco': {
    label: 'El Señor del Saco',
    keywords: ['senor del saco', 'saco', 'fichaje', 'renovacion', 'peligro', 'acecho']
  },
  'ee-leon-jamon': {
    label: 'León Jamonero (Cortando Jamón)',
    keywords: ['jamon', 'cortando jamon', 'vino', 'celebracion', 'calidad', 'pata negra']
  },
  'ee-urduri': {
    label: 'León Urduri (Nervioso)',
    keywords: ['urduri', 'nervios', 'unas', 'suspense', 'descuento', 'agonico']
  },
  'ee-iwilliams-pantera': {
    label: 'Iñaki Williams (La Pantera)',
    keywords: ['inaki williams', 'pantera', 'velocidad', 'delantero', 'gol']
  },
  'ee-nico-pina': {
    label: 'Nico Williams (La Piña)',
    keywords: ['nico williams', 'pina', 'pelo', 'mechas', 'regate', 'extremo']
  },
  'ee-williams-highfive': {
    label: 'Williams Brothers High-Five',
    keywords: ['williams', 'brothers', 'chocar cinco', 'inaki', 'nico', 'hermanos']
  },
  'ee-sancet-ciervo': {
    label: 'Oihan Sancet (El Ciervo)',
    keywords: ['sancet', 'ciervo', 'elegante', 'lince', 'mediapunta', 'gol']
  },
  'ee-areso-potro': {
    label: 'Jesús Areso (El Potro)',
    keywords: ['areso', 'potro', 'caballo', 'potencia', 'fuerza', 'carrilero']
  },
  'ee-sannadi-elefante': {
    label: 'Yanis Senhadji (El Elefante)',
    keywords: ['sannadi', 'elefante', 'tanque', 'delantero', 'fuerza']
  },
  'ee-djaloneta': {
    label: 'La Djaloneta',
    keywords: ['djalo', 'djaloneta', 'furgoneta', 'subanse', 'bocina']
  },
  'ee-valverde': {
    label: 'Ernesto Valverde (Txingurri)',
    keywords: ['valverde', 'txingurri', 'entrenador', 'cuclillas', 'mister', 'tactica']
  },
  'ee-unai-simon': {
    label: 'Unai Simón',
    keywords: ['simon', 'unai', 'portero', 'parada', 'muro', 'zamora']
  },
  'ee-mazinger-paradon': {
    label: 'Paradón Mazinger',
    keywords: ['mazinger', 'paradon', 'robot', 'blocaje', 'imparable']
  },
  'ee-punos-fuera': {
    label: '¡Puños fuera!',
    keywords: ['punos fuera', 'despeje', 'portero', 'salida']
  },
  'ee-gilda': {
    label: 'Gilda de Bilbao',
    keywords: ['gilda', 'pintxo', 'aceituna', 'anchoa', 'guindilla', 'poteo']
  },
  'ee-carolina': {
    label: 'La Carolina de Bilbao',
    keywords: ['carolina', 'pastel', 'merengue', 'dulce', 'bilbao']
  },
  'ee-baldosa': {
    label: 'Baldosa de Bilbao',
    keywords: ['baldosa', 'bilbao', 'suelo', 'simbolo', 'botxo']
  },
  'ee-gabarra': {
    label: 'La Gabarra',
    keywords: ['gabarra', 'campeones', 'ria', 'titulo', 'copa', 'celebracion']
  },
  'ee-sanmames': {
    label: 'San Mamés (La Catedral)',
    keywords: ['san mames', 'catedral', 'estadio', 'campo', 'arcos']
  },
  'ee-kalimotxo': {
    label: 'Vaso de Kalimotxo',
    keywords: ['kalimotxo', 'calimocho', 'fiesta', 'litro', 'bebida', 'partido']
  },
  'ee-garagardo': {
    label: 'Jarra de Garagardo (Cerveza)',
    keywords: ['garagardo', 'cerveza', 'birra', 'trago', 'brindis']
  },
  'ee-bakalaooo': {
    label: '¡Bakalaoooo!',
    keywords: ['bakalao', 'radio popular', 'gol', 'grito', 'celebracion']
  },
  'ee-pezbakalao': {
    label: 'Pez Bacalao',
    keywords: ['pez bacalao', 'bakalao', 'pescado', 'gol']
  },
  'ee-barrenon': {
    label: '¡Barrenon!',
    keywords: ['barrenon', 'gol', 'a la cazuela', 'euskera']
  },
  'ee-copa': {
    label: 'Copa del Rey',
    keywords: ['copa', 'trofeo', 'copa 25', 'campeon', 'sevilla', 'oro']
  },
  'ee-pozik-harrobi': {
    label: 'Pozik Harrobi (Lezama)',
    keywords: ['harrobi', 'cantera', 'lezama', 'cachorros', 'pozik', 'futuro']
  },
  'ee-trainera': {
    label: 'Trainera Bizkaitarra',
    keywords: ['trainera', 'remo', 'arun', 'equipo', 'bogar', 'bizkaia']
  },
  'ee-firma': {
    label: 'La Firma (Renovación)',
    keywords: ['firma', 'contrato', 'renovacion', 'pluma', 'fichaje']
  },
  'ee-muro': {
    label: 'El Muro',
    keywords: ['muro', 'defensa', 'ladrillo', 'cero', 'infranqueable']
  },
  'ee-grito': {
    label: 'Grito Athletic',
    keywords: ['grito', 'aupa', 'aliento', 'animo', 'grada']
  },
  'ee-rugido': {
    label: 'Rugido Zurigorri',
    keywords: ['rugido', 'sonido', 'leon', 'efecto']
  },
  'ee-angry-lion': {
    label: 'Angry Lion',
    keywords: ['angry lion', 'cartel', 'furia', 'leon']
  },
  'ee-lesion': {
    label: 'Cruz / Lesión',
    keywords: ['lesion', 'cruz roja', 'parte medico', 'baja']
  },
  'ee-jesus_txapela': {
    label: 'Sagrado Corazón con Txapela',
    keywords: ['sagrado corazon', 'txapela', 'bilbao', 'jesus', 'meme']
  }
};
export const STANDARD_EMOJI_CATEGORIES = [{
  id: 'smileys',
  name: 'Caras y Emociones',
  icon: 'far fa-smile',
  emojis: [{
    char: '😀',
    name: 'Cara sonriente',
    keywords: ['grinning', 'feliz', 'sonrisa', 'alegria']
  }, {
    char: '😃',
    name: 'Cara sonriente con ojos grandes',
    keywords: ['smiley', 'contento', 'alegre']
  }, {
    char: '😄',
    name: 'Sonrisa con ojos sonrientes',
    keywords: ['smile', 'sonrisa', 'felicidad']
  }, {
    char: '😁',
    name: 'Sonrisa radiante con ojos sonrientes',
    keywords: ['grin', 'dientes', 'alegre']
  }, {
    char: '😆',
    name: 'Sonrisa amplia con ojos cerrados',
    keywords: ['laughing', 'carcajada', 'risa']
  }, {
    char: '😅',
    name: 'Sonrisa con gota de sudor',
    keywords: ['sweat smile', 'alivio', 'nervios', 'sudor']
  }, {
    char: '🤣',
    name: 'Revolcándose de risa',
    keywords: ['rofl', 'partirse de risa', 'carcajadas', 'lol']
  }, {
    char: '😂',
    name: 'Llorando de risa',
    keywords: ['joy', 'lagrimas de risa', 'divertido', 'humor']
  }, {
    char: '🙂',
    name: 'Cara con sonrisa leve',
    keywords: ['slightly smiling', 'bien', 'calma']
  }, {
    char: '🙃',
    name: 'Cara al revés',
    keywords: ['upside down', 'ironia', 'sarcasmo', 'broma']
  }, {
    char: '😉',
    name: 'Cara guiñando un ojo',
    keywords: ['wink', 'guiño', 'complicidad']
  }, {
    char: '😊',
    name: 'Sonrisa modesta',
    keywords: ['blush', 'sonrojo', 'tierno', 'amable']
  }, {
    char: '😇',
    name: 'Cara con aureola',
    keywords: ['innocent', 'angel', 'santo', 'bueno']
  }, {
    char: '🥰',
    name: 'Cara con corazones',
    keywords: ['hearts', 'enamorado', 'amor', 'cuate']
  }, {
    char: '😍',
    name: 'Cara con ojos de corazón',
    keywords: ['heart eyes', 'amor', 'me encanta']
  }, {
    char: '🤩',
    name: 'Cara deslumbrada',
    keywords: ['star struck', 'estrellas', 'asombro', 'fan']
  }, {
    char: '😘',
    name: 'Cara lanzando un beso',
    keywords: ['kissing heart', 'beso', 'amor', 'cariño']
  }, {
    char: '😗',
    name: 'Cara besando',
    keywords: ['kiss', 'beso']
  }, {
    char: '😚',
    name: 'Cara besando con ojos cerrados',
    keywords: ['kissing closed eyes', 'beso tierno']
  }, {
    char: '😋',
    name: 'Cara saboreando comida',
    keywords: ['yum', 'rico', 'delicioso', 'hambre']
  }, {
    char: '😛',
    name: 'Cara sacando la lengua',
    keywords: ['tongue', 'lengua', 'burla']
  }, {
    char: '😜',
    name: 'Cara guiñando con lengua',
    keywords: ['wink tongue', 'broma', 'locura']
  }, {
    char: '🤪',
    name: 'Cara loca',
    keywords: ['zany', 'loco', 'descontrol', 'fiesta']
  }, {
    char: '😝',
    name: 'Cara con ojos cerrados y lengua',
    keywords: ['squint tongue', 'travesura']
  }, {
    char: '🤑',
    name: 'Cara con dinero en los ojos',
    keywords: ['money', 'dinero', 'rico', 'pasta']
  }, {
    char: '🤗',
    name: 'Cara con manos abrazando',
    keywords: ['hugs', 'abrazo', 'bienvenida']
  }, {
    char: '🤭',
    name: 'Cara con mano sobre la boca',
    keywords: ['hand over mouth', 'oops', 'secreta']
  }, {
    char: '🤫',
    name: 'Cara pidiendo silencio',
    keywords: ['shushing', 'silencio', 'callar', 'chito']
  }, {
    char: '🤔',
    name: 'Cara pensativa',
    keywords: ['thinking', 'pensando', 'duda', 'interrogante']
  }, {
    char: '🤐',
    name: 'Cara con cremallera en la boca',
    keywords: ['zipper', 'boca cerrada', 'secreto']
  }, {
    char: '🤨',
    name: 'Cara con ceja levantada',
    keywords: ['raised eyebrow', 'desconfianza', 'sospecha']
  }, {
    char: '😐',
    name: 'Cara neutral',
    keywords: ['neutral', 'serio', 'plano', 'meh']
  }, {
    char: '😑',
    name: 'Cara inexpresiva',
    keywords: ['expressionless', 'sin palabras', 'cansado']
  }, {
    char: '😶',
    name: 'Cara sin boca',
    keywords: ['no mouth', 'mudo', 'sin comentarios']
  }, {
    char: '😏',
    name: 'Cara con media sonrisa',
    keywords: ['smirk', 'vacile', 'pillo', 'ironico']
  }, {
    char: '😒',
    name: 'Cara descontenta',
    keywords: ['unamused', 'desagrado', 'harto']
  }, {
    char: '🙄',
    name: 'Cara con ojos en blanco',
    keywords: ['eye roll', 'pereza', 'harto', 'pesado']
  }, {
    char: '😬',
    name: 'Cara haciendo mueca de tensión',
    keywords: ['grimacing', 'incomodo', 'tierra tragame']
  }, {
    char: '🤥',
    name: 'Cara de pinocho',
    keywords: ['lying', 'mentira', 'humo', 'fantasma']
  }, {
    char: '😌',
    name: 'Cara de alivio',
    keywords: ['relieved', 'paz', 'alivio', 'tranquilidad']
  }, {
    char: '😔',
    name: 'Cara pensativa y triste',
    keywords: ['pensive', 'decepcion', 'pena']
  }, {
    char: '😪',
    name: 'Cara con sueño',
    keywords: ['sleepy', 'cansancio', 'bostezo']
  }, {
    char: '🤤',
    name: 'Cara babeando',
    keywords: ['drooling', 'baba', 'antojo']
  }, {
    char: '😴',
    name: 'Cara durmiendo',
    keywords: ['sleeping', 'dormir', 'zz']
  }, {
    char: '😷',
    name: 'Cara con mascarilla médica',
    keywords: ['mask', 'mascarilla', 'enfermo']
  }, {
    char: '🤒',
    name: 'Cara con termómetro',
    keywords: ['thermometer', 'fiebre', 'malo']
  }, {
    char: '🤕',
    name: 'Cara con vendaje',
    keywords: ['bandage', 'herida', 'golpe', 'lesion']
  }, {
    char: '🤢',
    name: 'Cara nauseabunda',
    keywords: ['nauseated', 'asco', 'vomera']
  }, {
    char: '🤮',
    name: 'Cara vomitando',
    keywords: ['vomiting', 'vomitar', 'repugnante']
  }, {
    char: '🤧',
    name: 'Cara estornudando',
    keywords: ['sneezing', 'resfriado', 'achis']
  }, {
    char: '🥵',
    name: 'Cara acalorada',
    keywords: ['hot', 'calor', 'bochorno', 'sudor']
  }, {
    char: '🥶',
    name: 'Cara congelada',
    keywords: ['cold', 'frio', 'helado']
  }, {
    char: '🥴',
    name: 'Cara mareada o ebria',
    keywords: ['woozy', 'borracho', 'resaca', 'mareo']
  }, {
    char: '😵',
    name: 'Cara noqueada',
    keywords: ['dizzy', 'KO', 'mareado']
  }, {
    char: '🤯',
    name: 'Cabeza explotando',
    keywords: ['exploding', 'mente rota', 'flipando']
  }, {
    char: '🤠',
    name: 'Cara con sombrero de vaquero',
    keywords: ['cowboy', 'vaquero']
  }, {
    char: '🥳',
    name: 'Cara de fiesta con matasuegras',
    keywords: ['partying', 'fiesta', 'celebracion', 'victoria']
  }, {
    char: '🥸',
    name: 'Cara disfrazada',
    keywords: ['disguise', 'disfraz', 'infiltrado']
  }, {
    char: '😎',
    name: 'Cara sonriente con gafas de sol',
    keywords: ['cool', 'gafas de sol', 'amo', 'jefe']
  }, {
    char: '🤓',
    name: 'Cara de empollón',
    keywords: ['nerd', 'gafas', 'estadisticas']
  }, {
    char: '🧐',
    name: 'Cara con monóculo',
    keywords: ['monocle', 'analisis', 'scouting', 'atento']
  }, {
    char: '😕',
    name: 'Cara confusa',
    keywords: ['confused', 'perdido', 'que pasa']
  }, {
    char: '😟',
    name: 'Cara preocupada',
    keywords: ['worried', 'preocupacion', 'miedo']
  }, {
    char: '🙁',
    name: 'Cara con el ceño fruncido',
    keywords: ['frown', 'tristeza']
  }, {
    char: '😮',
    name: 'Cara con boca abierta',
    keywords: ['open mouth', 'sorpresa']
  }, {
    char: '😯',
    name: 'Cara estupefacta',
    keywords: ['hushed', 'impresionado']
  }, {
    char: '😲',
    name: 'Cara asombrada',
    keywords: ['astonished', 'impacto']
  }, {
    char: '😳',
    name: 'Cara sonrojada con ojos grandes',
    keywords: ['flushed', 'verguenza', 'shock']
  }, {
    char: '🥺',
    name: 'Cara suplicante con ojos brillantes',
    keywords: ['pleading', 'por favor', 'pena', 'pena']
  }, {
    char: '😦',
    name: 'Cara con la boca abierta fruncida',
    keywords: ['frowning mouth']
  }, {
    char: '😧',
    name: 'Cara angustiada',
    keywords: ['anguished', 'angustia']
  }, {
    char: '😨',
    name: 'Cara asustada',
    keywords: ['fearful', 'miedo', 'panico']
  }, {
    char: '😰',
    name: 'Cara ansiosa con gota de sudor',
    keywords: ['anxious', 'ansiedad', 'nervios']
  }, {
    char: '😥',
    name: 'Cara triste pero aliviada',
    keywords: ['sad relieved']
  }, {
    char: '😢',
    name: 'Cara llorando con lágrima',
    keywords: ['crying', 'lagrima', 'triste']
  }, {
    char: '😭',
    name: 'Cara llorando a mares',
    keywords: ['sob', 'llanto', 'desesperacion', 'dolor']
  }, {
    char: '😱',
    name: 'Cara gritando de miedo',
    keywords: ['scream', 'grito', 'panico', 'pesadilla']
  }, {
    char: '😖',
    name: 'Cara de dolor o frustración',
    keywords: ['confounded', 'rabia']
  }, {
    char: '😣',
    name: 'Cara perseverante',
    keywords: ['persevering', 'aguantar']
  }, {
    char: '😞',
    name: 'Cara decepcionada',
    keywords: ['disappointed', 'decepcion']
  }, {
    char: '😓',
    name: 'Cara cabizbaja con sudor',
    keywords: ['sweat', 'agobio']
  }, {
    char: '😩',
    name: 'Cara cansada y quejumbrosa',
    keywords: ['weary', 'queja']
  }, {
    char: '😫',
    name: 'Cara exhausta',
    keywords: ['tired', 'agotado']
  }, {
    char: '🥱',
    name: 'Cara bostezando',
    keywords: ['yawning', 'aburrido', 'sueño']
  }, {
    char: '😤',
    name: 'Cara resoplando vapor',
    keywords: ['triumph', 'orgullo', 'furia contenida']
  }, {
    char: '😡',
    name: 'Cara enfadada y roja',
    keywords: ['pouting', 'furia', 'rabia', 'cabreo']
  }, {
    char: '😠',
    name: 'Cara enojada',
    keywords: ['angry', 'enfado', 'indignacion']
  }, {
    char: '🤬',
    name: 'Cara con símbolos en la boca',
    keywords: ['cursing', 'tacos', 'insultos', 'cagondios']
  }, {
    char: '😈',
    name: 'Diablillo sonriente',
    keywords: ['devil', 'diablo', 'maldad', 'picardia']
  }, {
    char: '👿',
    name: 'Diablo enfadado',
    keywords: ['imp', 'diablo furioso']
  }, {
    char: '💀',
    name: 'Calavera',
    keywords: ['skull', 'muerto', 'me muero']
  }, {
    char: '☠️',
    name: 'Calavera y tibias cruzadas',
    keywords: ['crossbones', 'peligro', 'muerte']
  }, {
    char: '💩',
    name: 'Caca con ojos',
    keywords: ['poop', 'mierda', 'partido horrible']
  }, {
    char: '🤡',
    name: 'Cara de payaso',
    keywords: ['clown', 'payaso', 'circo', 'ridiculo']
  }, {
    char: '👻',
    name: 'Fantasma',
    keywords: ['ghost', 'desaparecido', 'misterio']
  }, {
    char: '👽',
    name: 'Alien',
    keywords: ['alien', 'extraterrestre', 'otro planeta']
  }, {
    char: '🤖',
    name: 'Robot',
    keywords: ['robot', 'ia', 'inteligencia artificial']
  }]
}, {
  id: 'people',
  name: 'Gestos y Manos',
  icon: 'far fa-thumbs-up',
  emojis: [{
    char: '👍',
    name: 'Pulgar arriba',
    keywords: ['thumbs up', 'like', 'bien', 'de acuerdo', 'correcto']
  }, {
    char: '👎',
    name: 'Pulgar abajo',
    keywords: ['thumbs down', 'dislike', 'mal', 'desacuerdo']
  }, {
    char: '👏',
    name: 'Aplausos',
    keywords: ['clap', 'aplauso', 'bravo', 'ovacion', 'san mames']
  }, {
    char: '🙌',
    name: 'Manos levantadas celebrando',
    keywords: ['raising hands', 'aleluya', 'celebrar']
  }, {
    char: '👐',
    name: 'Manos abiertas',
    keywords: ['open hands']
  }, {
    char: '🤲',
    name: 'Palmas hacia arriba juntas',
    keywords: ['palms up together']
  }, {
    char: '🤝',
    name: 'Apretón de manos',
    keywords: ['handshake', 'trato hecho', 'acuerdo', 'fichaje']
  }, {
    char: '🙏',
    name: 'Manos juntas rezando o agradeciendo',
    keywords: ['pray', 'rezar', 'por favor', 'gracias', 'eskertu']
  }, {
    char: '✍️',
    name: 'Mano escribiendo',
    keywords: ['writing', 'escribir', 'firma', 'renovacion']
  }, {
    char: '💪',
    name: 'Bíceps flexionado (fuerza)',
    keywords: ['muscle', 'fuerza', 'musculo', 'potencia', 'animo']
  }, {
    char: '🖕',
    name: 'Dedo corazón',
    keywords: ['middle finger', 'corte de manga']
  }, {
    char: '✌️',
    name: 'Mano con señal de victoria o paz',
    keywords: ['peace', 'victoria', 'dos']
  }, {
    char: '🤞',
    name: 'Dedos cruzados',
    keywords: ['crossed fingers', 'suerte', 'ojala']
  }, {
    char: '🤟',
    name: 'Mano haciendo el signo te quiero',
    keywords: ['love you gesture']
  }, {
    char: '🤘',
    name: 'Mano con cuernos rockeros',
    keywords: ['horns', 'rock', 'metal', 'cana']
  }, {
    char: '🤙',
    name: 'Mano llamando',
    keywords: ['call me', 'shaka']
  }, {
    char: '👈',
    name: 'Mano señalando a la izquierda',
    keywords: ['point left']
  }, {
    char: '👉',
    name: 'Mano señalando a la derecha',
    keywords: ['point right']
  }, {
    char: '👆',
    name: 'Mano señalando hacia arriba',
    keywords: ['point up']
  }, {
    char: '👇',
    name: 'Mano señalando hacia abajo',
    keywords: ['point down']
  }, {
    char: '☝️',
    name: 'Índice apuntando hacia arriba',
    keywords: ['index up', 'atencion']
  }, {
    char: '👋',
    name: 'Mano saludando',
    keywords: ['wave', 'hola', 'adios', 'agur']
  }, {
    char: '🤚',
    name: 'Dorso de la mano levantado',
    keywords: ['raised back of hand']
  }, {
    char: '🖐️',
    name: 'Mano abierta con dedos separados',
    keywords: ['fingers splayed']
  }, {
    char: '✋',
    name: 'Mano levantada abierta',
    keywords: ['stop', 'alto', 'mano']
  }, {
    char: '🖖',
    name: 'Saludo vulcano',
    keywords: ['vulcan', 'spock']
  }, {
    char: '👌',
    name: 'Mano en OK',
    keywords: ['ok', 'perfecto']
  }, {
    char: '🤌',
    name: 'Mano con dedos juntos (ma che vuoi)',
    keywords: ['pinched fingers', 'que dices']
  }, {
    char: '🤏',
    name: 'Mano haciendo poco',
    keywords: ['pinching hand', 'un poco', 'justo']
  }, {
    char: '✊',
    name: 'Puño levantado',
    keywords: ['raised fist', 'resistencia', 'lucha']
  }, {
    char: '👊',
    name: 'Puñetazo al frente',
    keywords: ['punch', 'golpe']
  }, {
    char: '🤛',
    name: 'Puño hacia la izquierda',
    keywords: ['fist left']
  }, {
    char: '🤜',
    name: 'Puño hacia la derecha',
    keywords: ['fist right']
  }, {
    char: '👀',
    name: 'Ojos mirando',
    keywords: ['eyes', 'mirada', 'atento', 'ojo', 'rumor']
  }, {
    char: '👁️',
    name: 'Ojo',
    keywords: ['eye']
  }, {
    char: '🧠',
    name: 'Cerebro',
    keywords: ['brain', 'cabeza', 'tactica', 'inteligencia']
  }, {
    char: '🫀',
    name: 'Corazón anatómico',
    keywords: ['heart organ']
  }, {
    char: '🫁',
    name: 'Pulmones',
    keywords: ['lungs', 'pulmon', 'fondo']
  }, {
    char: '🦷',
    name: 'Diente',
    keywords: ['tooth']
  }, {
    char: '🦴',
    name: 'Hueso',
    keywords: ['bone']
  }, {
    char: '👅',
    name: 'Lengua',
    keywords: ['tongue']
  }, {
    char: '👄',
    name: 'Labios',
    keywords: ['mouth']
  }, {
    char: '💋',
    name: 'Beso con pintalabios',
    keywords: ['kiss mark']
  }]
}, {
  id: 'sports',
  name: 'Deportes y Fiesta',
  icon: 'fas fa-futbol',
  emojis: [{
    char: '⚽',
    name: 'Balón de fútbol',
    keywords: ['soccer', 'futbol', 'pelota', 'balon', 'partido']
  }, {
    char: '🥅',
    name: 'Portería de fútbol',
    keywords: ['goal net', 'porteria', 'red', 'gol']
  }, {
    char: '🏆',
    name: 'Trofeo de oro',
    keywords: ['trophy', 'copa', 'campeon', 'titulo', 'ganador']
  }, {
    char: '🥇',
    name: 'Medalla de oro (1º puesto)',
    keywords: ['gold medal', 'oro', 'primero']
  }, {
    char: '🥈',
    name: 'Medalla de plata (2º puesto)',
    keywords: ['silver medal', 'plata']
  }, {
    char: '🥉',
    name: 'Medalla de bronce (3º puesto)',
    keywords: ['bronze medal', 'bronce']
  }, {
    char: '🎖️',
    name: 'Medalla militar',
    keywords: ['medal']
  }, {
    char: '🏅',
    name: 'Medalla deportiva',
    keywords: ['sports medal']
  }, {
    char: '🏟️',
    name: 'Estadio',
    keywords: ['stadium', 'san mames', 'catedral', 'grada']
  }, {
    char: '🥊',
    name: 'Guante de boxeo',
    keywords: ['boxing glove', 'boxeo', 'pelea']
  }, {
    char: '🥋',
    name: 'Uniforme de artes marciales',
    keywords: ['martial arts']
  }, {
    char: '🎾',
    name: 'Pelota de tenis',
    keywords: ['tennis']
  }, {
    char: '🏀',
    name: 'Balón de baloncesto',
    keywords: ['basketball']
  }, {
    char: '🏐',
    name: 'Voleibol',
    keywords: ['volleyball']
  }, {
    char: '🏈',
    name: 'Fútbol americano',
    keywords: ['football']
  }, {
    char: '🏉',
    name: 'Rugby',
    keywords: ['rugby']
  }, {
    char: '⚾',
    name: 'Béisbol',
    keywords: ['baseball']
  }, {
    char: '🥎',
    name: 'Sóftbol',
    keywords: ['softball']
  }, {
    char: '🏓',
    name: 'Ping-pong',
    keywords: ['ping pong']
  }, {
    char: '🏸',
    name: 'Bádminton',
    keywords: ['badminton']
  }, {
    char: '⛳',
    name: 'Golf',
    keywords: ['golf']
  }, {
    char: '🎯',
    name: 'Diana en el centro',
    keywords: ['bullseye', 'diana', 'punteria']
  }, {
    char: '🎱',
    name: 'Bola 8 de billar',
    keywords: ['billiards', 'bola 8']
  }, {
    char: '🎮',
    name: 'Mando de videojuegos',
    keywords: ['video game', 'gamer', 'consola']
  }, {
    char: '🎲',
    name: 'Dado',
    keywords: ['dice', 'azar', 'suerte']
  }, {
    char: '🎳',
    name: 'Bolos',
    keywords: ['bowling']
  }, {
    char: '🧗',
    name: 'Escalador',
    keywords: ['climbing', 'escalada']
  }, {
    char: '🚴',
    name: 'Ciclista',
    keywords: ['biking', 'ciclismo']
  }, {
    char: '🏋️',
    name: 'Halterofilia / Gimnasio',
    keywords: ['weight lifting', 'pesas', 'gym']
  }, {
    char: '🏃',
    name: 'Persona corriendo',
    keywords: ['running', 'carrera', 'velocidad']
  }, {
    char: '🎉',
    name: 'Cañón de confeti',
    keywords: ['party popper', 'fiesta', 'celebracion', 'victoria']
  }, {
    char: '🎊',
    name: 'Bola de confeti',
    keywords: ['confetti ball', 'fiesta']
  }, {
    char: '🥳',
    name: 'Celebración',
    keywords: ['partying face']
  }, {
    char: '🍻',
    name: 'Brindis de cervezas',
    keywords: ['cheers', 'cerveza', 'brindis', 'poteo']
  }, {
    char: '🍾',
    name: 'Botella de champán descorchada',
    keywords: ['champagne', 'descorche', 'celebrar']
  }]
}, {
  id: 'food',
  name: 'Comida y Poteo',
  icon: 'fas fa-beer',
  emojis: [{
    char: '🍺',
    name: 'Jarra de cerveza',
    keywords: ['beer', 'cerveza', 'garagardo', 'birra', 'pinta']
  }, {
    char: '🍻',
    name: 'Dos jarras de cerveza brindando',
    keywords: ['beers', 'brindis', 'salud', 'topa']
  }, {
    char: '🍷',
    name: 'Copa de vino',
    keywords: ['wine', 'vino', 'rioxa', 'txakoli']
  }, {
    char: '🍾',
    name: 'Botella de cava o champán',
    keywords: ['champagne', 'cava', 'botella']
  }, {
    char: '🥂',
    name: 'Copas de brindis',
    keywords: ['clinking glasses', 'brindis']
  }, {
    char: '🥃',
    name: 'Vaso de licor o whisky',
    keywords: ['whisky', 'cubata', 'copa']
  }, {
    char: '🍸',
    name: 'Cóctel',
    keywords: ['cocktail']
  }, {
    char: '🍹',
    name: 'Bebida tropical',
    keywords: ['tropical drink']
  }, {
    char: '🥤',
    name: 'Vaso con pajita',
    keywords: ['cup with straw', 'refresco']
  }, {
    char: '☕',
    name: 'Taza de café',
    keywords: ['coffee', 'cafe', 'desayuno']
  }, {
    char: '🥩',
    name: 'Chuleta de carne',
    keywords: ['cut of meat', 'txuleton', 'carne', 'chuletilla']
  }, {
    char: '🍖',
    name: 'Carne con hueso',
    keywords: ['meat on bone']
  }, {
    char: '🍗',
    name: 'Muslo de pollo',
    keywords: ['poultry leg']
  }, {
    char: '🥓',
    name: 'Panceta / Bacon',
    keywords: ['bacon']
  }, {
    char: '🍔',
    name: 'Hamburguesa',
    keywords: ['hamburger', 'burger']
  }, {
    char: '🍟',
    name: 'Patatas fritas',
    keywords: ['french fries']
  }, {
    char: '🍕',
    name: 'Porción de pizza',
    keywords: ['pizza']
  }, {
    char: '🌭',
    name: 'Perrito caliente',
    keywords: ['hot dog']
  }, {
    char: '🥪',
    name: 'Sándwich',
    keywords: ['sandwich']
  }, {
    char: '🌮',
    name: 'Taco',
    keywords: ['taco']
  }, {
    char: '🌯',
    name: 'Burrito',
    keywords: ['burrito']
  }, {
    char: '🥖',
    name: 'Barra de pan',
    keywords: ['baguette', 'pan']
  }, {
    char: '🧀',
    name: 'Cuña de queso',
    keywords: ['cheese', 'idiazabal', 'queso']
  }, {
    char: '🍳',
    name: 'Huevo frito en sartén',
    keywords: ['egg', 'huevo frito']
  }, {
    char: '🥘',
    name: 'Sartén con comida / Paella',
    keywords: ['shallow pan', 'paella', 'arroz']
  }, {
    char: '🍲',
    name: 'Tazón de guiso o sopa',
    keywords: ['pot of food', 'guiso', 'marmitako']
  }, {
    char: '🍿',
    name: 'Palomitas de maíz',
    keywords: ['popcorn', 'palomitas', 'drama']
  }, {
    char: '🍫',
    name: 'Tableta de chocolate',
    keywords: ['chocolate']
  }, {
    char: '🍰',
    name: 'Tarta de fresa',
    keywords: ['shortcake', 'pastel', 'dulce']
  }, {
    char: '🎂',
    name: 'Tarta de cumpleaños',
    keywords: ['birthday cake', 'cumpleanos', 'aniversario']
  }]
}, {
  id: 'animals',
  name: 'Animales',
  icon: 'fas fa-paw',
  emojis: [{
    char: '🦁',
    name: 'León',
    keywords: ['lion', 'leon', 'athletic', 'lehoia', 'rey']
  }, {
    char: '🐯',
    name: 'Tigre',
    keywords: ['tiger', 'tigre']
  }, {
    char: '🐆',
    name: 'Leopardo',
    keywords: ['leopard', 'pantera']
  }, {
    char: '🐺',
    name: 'Lobo',
    keywords: ['wolf', 'lobo']
  }, {
    char: '🦊',
    name: 'Zorro',
    keywords: ['fox', 'zorro']
  }, {
    char: '🐱',
    name: 'Gato',
    keywords: ['cat', 'gato']
  }, {
    char: '🐶',
    name: 'Perro',
    keywords: ['dog', 'perro']
  }, {
    char: '🦌',
    name: 'Ciervo',
    keywords: ['deer', 'ciervo', 'sancet']
  }, {
    char: '🐂',
    name: 'Toro',
    keywords: ['ox', 'toro', 'berenguer']
  }, {
    char: '🐎',
    name: 'Caballo al galope',
    keywords: ['horse', 'potro', 'areso', 'velocidad']
  }, {
    char: '🐘',
    name: 'Elefante',
    keywords: ['elephant', 'elefante', 'senhadji']
  }, {
    char: '🐻',
    name: 'Oso',
    keywords: ['bear', 'oso']
  }, {
    char: '🐼',
    name: 'Panda',
    keywords: ['panda']
  }, {
    char: '🦅',
    name: 'Águila',
    keywords: ['eagle', 'aguila']
  }, {
    char: '🦉',
    name: 'Búho',
    keywords: ['owl', 'buho']
  }, {
    char: '🦈',
    name: 'Tiburón',
    keywords: ['shark', 'tiburon']
  }, {
    char: '🐬',
    name: 'Delfín',
    keywords: ['dolphin']
  }, {
    char: '🐟',
    name: 'Pez',
    keywords: ['fish', 'bakalao', 'pescado']
  }, {
    char: '🐍',
    name: 'Serpiente',
    keywords: ['snake']
  }, {
    char: '🦍',
    name: 'Gorila',
    keywords: ['gorilla']
  }]
}, {
  id: 'symbols',
  name: 'Símbolos y Pasión',
  icon: 'fas fa-heart',
  emojis: [{
    char: '❤️',
    name: 'Corazón rojo',
    keywords: ['red heart', 'rojo', 'athletic', 'amor']
  }, {
    char: '🤍',
    name: 'Corazón blanco',
    keywords: ['white heart', 'blanco', 'zurigorri']
  }, {
    char: '🖤',
    name: 'Corazón negro',
    keywords: ['black heart']
  }, {
    char: '💔',
    name: 'Corazón roto',
    keywords: ['broken heart', 'derrota']
  }, {
    char: '❣️',
    name: 'Exclamación de corazón',
    keywords: ['heart exclamation']
  }, {
    char: '💕',
    name: 'Dos corazones',
    keywords: ['two hearts']
  }, {
    char: '🔥',
    name: 'Fuego',
    keywords: ['fire', 'fuego', 'on fire', 'golazo', 'caliente']
  }, {
    char: '✨',
    name: 'Destellos o chispas',
    keywords: ['sparkles', 'magia', 'brillante']
  }, {
    char: '⚡',
    name: 'Rayo de alta tensión',
    keywords: ['zap', 'rayo', 'energia', 'velocidad']
  }, {
    char: '💥',
    name: 'Explosión',
    keywords: ['boom', 'bomba', 'disparo', 'misil']
  }, {
    char: '💯',
    name: 'Cien puntos',
    keywords: ['hundred', '100', 'perfecto', 'diez de diez']
  }, {
    char: '💢',
    name: 'Símbolo de enfado',
    keywords: ['anger', 'venas', 'rabia']
  }, {
    char: '💣',
    name: 'Bomba',
    keywords: ['bomb', 'bombazo', 'fichaje', 'exclusiva']
  }, {
    char: '🚨',
    name: 'Sirena policial / Alerta',
    keywords: ['rotating light', 'alerta', 'urgente', 'oficial']
  }, {
    char: '📢',
    name: 'Megáfono',
    keywords: ['loudspeaker', 'comunicado', 'aviso']
  }, {
    char: '🔔',
    name: 'Campana',
    keywords: ['bell', 'notificacion']
  }, {
    char: '🔴',
    name: 'Círculo rojo',
    keywords: ['red circle', 'rojo', 'athletic']
  }, {
    char: '⚪',
    name: 'Círculo blanco',
    keywords: ['white circle', 'blanco']
  }, {
    char: '🟥',
    name: 'Cuadrado rojo',
    keywords: ['red square', 'tarjeta roja']
  }, {
    char: '🟨',
    name: 'Cuadrado amarillo',
    keywords: ['yellow square', 'tarjeta amarilla']
  }, {
    char: '✅',
    name: 'Marca de verificación verde',
    keywords: ['check mark', 'correcto', 'oficial']
  }, {
    char: '❌',
    name: 'Cruz roja',
    keywords: ['cross mark', 'error', 'no']
  }, {
    char: '⛔',
    name: 'Dirección prohibida',
    keywords: ['no entry', 'prohibido']
  }, {
    char: '⚠️',
    name: 'Señal de advertencia',
    keywords: ['warning', 'cuidado', 'ojo']
  }, {
    char: '🏁',
    name: 'Bandera de cuadros',
    keywords: ['checkered flag', 'meta', 'final']
  }, {
    char: '🚩',
    name: 'Bandera triangular roja',
    keywords: ['triangular flag', 'bandera roja']
  }, {
    char: '🇪🇸',
    name: 'Bandera de España',
    keywords: ['flag spain']
  }, {
    char: '🇫🇷',
    name: 'Bandera de Francia',
    keywords: ['flag france']
  }, {
    char: '🇲🇽',
    name: 'Bandera de México',
    keywords: ['flag mexico', 'padilla']
  }, {
    char: '🇬🇭',
    name: 'Bandera de Ghana',
    keywords: ['flag ghana', 'williams']
  }, {
    char: '🇪🇺',
    name: 'Bandera de Europa',
    keywords: ['flag european union', 'europa', 'champions', 'europa league']
  }]
}];
flarum.reg.add('nagusi-match-ratings', 'forum/custom-emojis/emojiData', { CUSTOM_EMOJI_METADATA: CUSTOM_EMOJI_METADATA,STANDARD_EMOJI_CATEGORIES: STANDARD_EMOJI_CATEGORIES, });